import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "option flex items-center q-mb-sm" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle q-mr-md"
}
const _hoisted_4 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_label_box = _resolveComponent("label-box")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(_ctx.propName), 1))
        : (!_ctx.newPropMode)
          ? (_openBlock(), _createBlock(_component_q_select, {
              key: 1,
              class: "q-mr-md",
              modelValue: _ctx.activeProption,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeProption) = $event)),
              options: _ctx.proptions,
              "popup-content-class": "prop-select",
              dense: ""
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newPropMode = true)),
                  icon: "add",
                  size: "sm",
                  flat: "",
                  round: "",
                  tabindex: "-1"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "options"]))
          : (_openBlock(), _createBlock(_component_q_input, {
              key: 2,
              class: "new-prop-input",
              dense: "",
              outlined: "",
              modelValue: _ctx.newProp.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newProp.name) = $event)),
              style: {"position":"relative"}
            }, {
              before: _withCtx(() => [
                _createVNode(_component_q_chip, {
                  class: "new-chip",
                  dense: "",
                  square: ""
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("New")
                  ])),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPropMode = false)),
                  icon: "undo",
                  size: "sm",
                  flat: "",
                  round: "",
                  tabindex: "-1"
                })
              ]),
              counter: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("span", null, "New", -1)
              ])),
              _: 1
            }, 8, ["modelValue"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_label_box, {
        class: "prop-value",
        "model-value": _ctx.fastPropValue,
        editing: _ctx.editing,
        options: _ctx.propValueOptions,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => {_ctx.fastPropValue = $event; _ctx.updatePropValue($event)})
      }, null, 8, ["model-value", "editing", "options"]),
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_TrashIcon, {
            key: 0,
            class: "q-ml-sm remove",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('remove', _ctx.propId))),
            size: "16px"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}